import { gql } from "@apollo/client";

export const getUnseenFeatureAnnouncementsQuery = gql`
  query GetUnseenFeatureAnnouncements($app: String!) {
    getUnseenFeatureAnnouncements(app: $app) {
      message
      response
    }
  }
`;
